export default class BefehlsnachrichtUnknownVisuellerStatusError extends Error {
  public visuellerStatus: string

  constructor(visuellerStatus: string) {
    super(`Statusprüfung: unbekannter visueller Status "${visuellerStatus}".`)
    this.visuellerStatus = visuellerStatus
    this.name = 'BefehlsnachrichtUnknownVisuellerStatusError'
  }
}
